import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-95a570ec")

_pushScopeId("data-v-95a570ec")
const _hoisted_1 = {
  key: 0,
  class: "p-2 bg-tag text-dark-blue mx-0.5 rounded text-12 flex items-center whitespace-nowrap"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")

  return (_openBlock(), _createBlock("div", {
    class: [
      'bg-white h-20 border rounded-md focus:outline-primary overflow-hidden py-2 px-4 flex items-center',
      _ctx.isInputFocused ? 'border-input-focus' : 'border-input-main'
    ]
  }, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.keywords, (keyword, index) => {
      return (_openBlock(), _createBlock(_Fragment, { key: index }, [
        (index !== _ctx.keywords.length - 1)
          ? (_openBlock(), _createBlock("div", _hoisted_1, [
              _createTextVNode(_toDisplayString(keyword) + " ", 1),
              _createVNode("div", {
                onClick: ($event: any) => (_ctx.removeIcon(index))
              }, [
                _createVNode(_component_font_awesome_icon, {
                  class: "ml-1 hover:opacity-50 cursor-pointer",
                  icon: ['fas', 'times']
                })
              ], 8, ["onClick"])
            ]))
          : _createCommentVNode("", true)
      ], 64))
    }), 128)),
    _withDirectives(_createVNode("input", {
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.localValue = $event)),
      name: "keywords",
      class: "placeholder-gray-300 ml-2 w-full",
      placeholder: _ctx.$t('dashboard.text-search-area.tabs.keywords.placeholder'),
      onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isInputFocused = true)),
      onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isInputFocused = false)),
      onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onKeyPress && _ctx.onKeyPress(...args))),
      onKeydown: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onKeyPress && _ctx.onKeyPress(...args)))
    }, null, 40, ["placeholder"]), [
      [_vModelText, _ctx.localValue]
    ])
  ], 2))
})